export const domainTag = 'frontend_portal_';

export const frontEndFlags = [
  'addSalesChannelTypeToStoreVisibility',
  'addStoresButton',
  'alertBannerInvoice',
  'deliveryLeadTime',
  'freeDeliveryFeeVoucher',
  'hideNextOptionSetButtonOnSkip',
  'hideStoresPage2',
  'internationalisedAddress',
  'loyaltyMaxDiscount',
  'menuItemVoucher',
  'nestedModifiers',
  'orderFulfillmentStatusConfigurations',
  'orderFulfillmentStatusOrderDetails',
  'paygreenFeatures',
  'showBannerAlertForIntegratedMenus',
  'showAllMenusInEditor',
  'showPayoutsStoreOptions',
  'showPosInPayoutReport',
  'showPropertiesScreen',
  'showRMS',
  'showPropertyManagementPermissions',
  'hideStoreManagementPermissions',
  'tablePrefix',
  'tippingCustom',
  'tippingReduceValues',
  'tippingRoundUp',
  'useInjectedRecaptchaKey',
  'useNewPayoutV3Report',
  'payoutsV3PayoutsByStore',
  'voucherChannel',
  'voucherDiscoverable',
  'voucherLimitAvailability',
  'voucherValidPeriod',
  'showSmsCampaigns',
  'homeOnBrandChange',
  'showRMSMenuSelectorForFDSalesChannels',
  'showSalesChannelStructure',
  'allowUpdateToBankingVatNumber',
  'redirectOrgToBrand',
  'enablePostcodePolygons',
  'enablePostcodePolygonsMultiple',
  'useStoresToSalesChannelRedirect',
  'showGoogleListingManagement',
  'enableMicroFrontendExampleManifestFile',
  'enableManifestMenuEditor',
  'showMenuListingV3',
  'showMenuEditorV3',
  'menuV3_showBulkActions',
  'menuV3_showScheduling',
  'menuV3_showRevertMenuButton',
  'menuV3_showUnifiedItemsView',
  'menuV3_showUnifiedModifiersView',
  'moveWebToAppRedirectSetting',
  'enableManifestRestaurantLayoutDesigner',
  'disablePropertyManagerLevelAddOns',
  'enableIntercomCompanySync',
  'simplifiedRetentionCampaign',
  'showPortalSearch',
  'showAppendedSalesChannelTypes',
  'enableNewWebhooksSystem',
  'fpmAllowPhoneAgentType',
  'enableOnboardingV3WizardConfig',
  'enableOnboardingV3WizardAutoSave',
  'showCollectionSettingsAtPropertyLevel',
  'smsRegistration',
  'voucherFilteringImprovements',
  'customerVoucher',
  'showAssignedVouchersCustomerPage',
  'showVerifactuLink',
  'showAuthMenuItem',
  'showForceDiscount',
  'reportCategoryVisibility',
  'useGbpSearchFallbackTitlePostalCode',
] as const;

export type FrontEndFlag = (typeof frontEndFlags)[number];
